var CoreAuthProviderClient = (function () {
    function CoreAuthProviderClient(providerName, requestClient, baseRoute) {
        this.providerName = providerName;
        this.requestClient = requestClient;
        this.baseRoute = baseRoute;
    }
    return CoreAuthProviderClient;
}());
export default CoreAuthProviderClient;
//# sourceMappingURL=CoreAuthProviderClient.js.map